import { Dropdown, TextField } from '@symphony-ui/uitoolkit-components';
import * as React from 'react';
import PopupContext from 'contexts/PopupContext';
const RatingsLine = ({ agencyOptions, currentAgencies, isDisabled, onChange, rating }) => {
    const { setBlockClose } = React.useContext(PopupContext);
    const onChangeAgency = React.useCallback((event) => {
        const { value } = event.target;
        const newRating = { agency: value.value, value: rating.value };
        onChange(newRating);
        setBlockClose(false);
    }, [onChange, rating.value, setBlockClose]);
    const onChangeValue = React.useCallback((event) => {
        const { value } = event.target;
        const newRating = { agency: rating.agency, value };
        onChange(newRating);
    }, [onChange, rating.agency]);
    const onMenuOpen = React.useCallback(() => {
        setBlockClose(true);
    }, [setBlockClose]);
    const label = React.useMemo(() => agencyOptions.find(o => 'value' in o && o.value === rating.agency)?.label, [agencyOptions, rating.agency]);
    const onMenuClose = React.useCallback(() => {
        setBlockClose(false);
    }, [setBlockClose]);
    const isOptionDisabled = React.useCallback((agency) => !('value' in agency) || currentAgencies.includes(agency.value), [currentAgencies]);
    return (React.createElement("div", { style: { display: 'flex', justifyContent: 'space-between' } },
        label !== undefined ?
            React.createElement("div", { style: { width: '8rem' } }, label) :
            React.createElement("div", { style: { width: '8rem' } },
                React.createElement(Dropdown, { isOptionDisabled: isOptionDisabled, onChange: onChangeAgency, onMenuOpen: onMenuOpen, onMenuClose: onMenuClose, options: agencyOptions, style: { width: '20rem' }, value: agencyOptions.find(o => 'value' in o && o.value === rating.agency) })),
        React.createElement(TextField, { className: "co-ratings-input", disabled: isDisabled, onChange: onChangeValue, value: rating.value })));
};
export default RatingsLine;
